import React from 'react'
import { observer } from 'mobx-react-lite'
import ContentHtml from './..//content/ContentHtml/ContentHtml.component'

const ReferralProgramComponent = ({ content }) => {
  if (content && typeof content === 'object') {
    return (
      <div
        id="ReferralProgramComponent"
        style={{ marginLeft: '10%', marginRight: '10%' }}
      >
        <div
          style={{
            padding: '20px',
            backgroundColor: 'white',
            borderRadius: '10px',
          }}
        >
          <div dangerouslySetInnerHTML={{ __html: content?.program || '' }} />
          <div dangerouslySetInnerHTML={{ __html: content?.form || '' }} />
        </div>
        <script src="https://team.bmagencybuilders.com/js/form_embed.js"></script>
      </div>
    )
  }

  return (
    <div
      id="ReferralProgramComponent"
      style={{ marginLeft: '10%', marginRight: '10%' }}
    >
      <div
        style={{
          padding: '20px',
          backgroundColor: 'white',
          borderRadius: '10px',
        }}
      >
        <ContentHtml contentId="35" />
        <ContentHtml contentSlug="referral-form-page" />
      </div>
      <script src="https://team.bmagencybuilders.com/js/form_embed.js"></script>
    </div>
  )
}

export default observer(ReferralProgramComponent)
